import { Container } from '@mui/material';
import LoginFormLogo from '../../../assets/svg/avery_sv_logo.png';

export const Logo = () => {
  return (
    <img width={'160px'} className="logoIMG" src={LoginFormLogo} alt="Logo" />
  );
};
